import { useEffect, useState } from "react";
import { Loader2, Plus, Trash2, Check, ListChecks } from "lucide-react";
import { api } from "@/lib/api";

const overline = "hr-overline text-blaze text-[11px]";
const inputCls = "w-full bg-white/5 border border-white/15 rounded px-3.5 py-2.5 outline-none focus:border-blaze text-bone text-sm placeholder:text-bone/30";

export function HuntChecklist({ huntId }) {
  const [tasks, setTasks] = useState(null);
  const [title, setTitle] = useState("");

  useEffect(() => { api.huntChecklist(huntId).then((d) => setTasks(d.tasks)).catch(() => setTasks([])); }, [huntId]);

  const add = async () => {
    if (!title.trim()) return;
    const { task } = await api.addTask(huntId, title.trim());
    setTasks((t) => [...t, task]); setTitle("");
  };
  const toggle = async (t) => {
    setTasks((list) => list.map((x) => x.id === t.id ? { ...x, done: !x.done } : x));
    await api.updateTask(huntId, t.id, { done: !t.done });
  };
  const del = async (id) => { setTasks((list) => list.filter((x) => x.id !== id)); await api.deleteTask(huntId, id); };

  if (!tasks) return <div className="py-8 grid place-items-center"><Loader2 className="animate-spin text-blaze" /></div>;
  const done = tasks.filter((t) => t.done).length;

  return (
    <div data-testid="workspace-checklist">
      <div className="flex items-center gap-2"><ListChecks size={15} className="text-blaze" /><span className={overline}>Preparation checklist</span>{tasks.length > 0 && <span className="text-bone/40 text-xs ml-1">{done}/{tasks.length} done</span>}</div>
      {tasks.length > 0 && <div className="h-1.5 bg-white/10 rounded-full overflow-hidden mt-3"><div className="h-full bg-forest rounded-full transition-all" style={{ width: `${Math.round((done / tasks.length) * 100)}%` }} /></div>}
      <div className="mt-4 space-y-2">
        {tasks.map((t) => (
          <div key={t.id} className="flex items-center gap-3 bg-white/5 border border-white/10 rounded px-3.5 py-2.5" data-testid={`task-${t.id}`}>
            <button onClick={() => toggle(t)} className={`w-5 h-5 rounded border grid place-items-center transition-colors ${t.done ? "bg-forest border-forest" : "border-white/30 hover:border-blaze"}`} data-testid={`task-toggle-${t.id}`}>{t.done && <Check size={13} className="text-white" />}</button>
            <span className={`flex-1 text-sm ${t.done ? "line-through text-bone/40" : "text-bone/85"}`}>{t.title}</span>
            <button onClick={() => del(t.id)} className="text-bone/30 hover:text-red-400" data-testid={`task-delete-${t.id}`}><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
      <div className="flex gap-2 mt-3">
        <input value={title} onChange={(e) => setTitle(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Add a task (e.g. Zero rifle, book lodging)" className={inputCls} data-testid="task-input" />
        <button onClick={add} className="bg-white/10 hover:bg-blaze hover:text-white rounded px-4 transition-colors" data-testid="task-add"><Plus size={17} /></button>
      </div>
      <p className="text-bone/40 text-xs mt-3">Your tasks, your list. HomeRange won&apos;t invent legal requirements — always verify regulations with the official source.</p>
    </div>
  );
}
